import { createImageRenderer, standardTileName } from './imageRenderer.jsx'

// FluffyStuff riichi-mahjong-tiles (Regular/white variant), CC0 public domain.
// https://github.com/FluffyStuff/riichi-mahjong-tiles — SVG viewBox 300x400.
// Face SVGs carry only the artwork; the tile body is Front.svg stacked beneath.
export const fluffyRenderer = createImageRenderer({
  basePath: '/tiles/fluffystuff',
  filesFor: (code) => (code === 'xx' ? ['Back'] : ['Front', standardTileName(code)]),
  aspect: 400 / 300,
  ext: 'svg',
})

export default fluffyRenderer
